import React, { useEffect, useMemo } from 'react';
import TopBanner from './top_banner';
import globalHelper from '../../helpers/functions/global.helper';
import { isRichTextEmpty } from '../../helpers/functions/rich_text.helper';

const TopBannerNormalTicket = ({ park, bannerHeight, setBanner, }) => {
    const bannerQuill = useMemo(() => {
        return !isRichTextEmpty(park?.banner_text) ? park?.banner_text : null;
    }, [park?.banner_text])

    // if banner quill existing, then set to wrapper to tell it
    useEffect(() => {
        if(bannerQuill){
            setBanner?.(true);
        }
    }, [bannerQuill])

    return (
        <>
            {
                bannerQuill && (
                    <>
                        <TopBanner height={bannerHeight} bannerQuill={bannerQuill} type='info' />
                    </>
                )
            }
        </>
    );
}

export default TopBannerNormalTicket;